import React, { useRef, useState, useEffect } from "react";
import { Box, Typography } from "@mzc-pdc/ui";
import Tooltip from "@components_v2/Tooltip/tooltip";

/**
 * EllipsisTooltip - 텍스트가 지정된 너비를 초과하여 ellipsis 처리될 때 툴팁을 표시하는 컴포넌트
 */
const EllipsisTooltip = ({
    text,
    maxWidth,
    sx = {},
    variant = "body2",
    placement = "bottom",
    typographyProps = {},
    boxProps = {},
    ...otherProps
}) => {
    const textRef = useRef(null);
    const [isEllipsed, setIsEllipsed] = useState(false);

    useEffect(() => {
        const checkEllipsis = () => {
            if (textRef.current) {
                // scrollWidth가 clientWidth보다 크면 ellipsis가 발생한 것
                setIsEllipsed(textRef.current.scrollWidth > textRef.current.clientWidth);
            }
        };

        checkEllipsis();

        let rafId;
        const resizeObserver = new ResizeObserver(() => {
            rafId = requestAnimationFrame(checkEllipsis);
        });
        if (textRef.current) {
            resizeObserver.observe(textRef.current);
        }

        return () => {
            cancelAnimationFrame(rafId);
            resizeObserver.disconnect();
        };
    }, [text]);

    return (
        <Box
            sx={{
                ...sx,
                maxWidth: maxWidth,
            }}
            {...boxProps}
        >
            <Tooltip title={isEllipsed ? text : ""} placement={placement} {...otherProps}>
                <Typography
                    ref={textRef}
                    variant={variant}
                    sx={{
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "100%",
                        ...typographyProps.sx,
                    }}
                    {...typographyProps}
                >
                    {text}
                </Typography>
            </Tooltip>
        </Box>
    );
};

export default EllipsisTooltip;
